<template>
    <div class="account-list">
        <van-cell-group v-if="type == 'bankWithdraw'">
            <template #title>
                <div class="account-group-title">
                    <span class="group-title">
                        <span style="color: black;">银行卡</span>
                        <span style="margin-left: 8px; font-size: 11px; color:red">24小时内到账</span>
                    </span>
                    <span class="group-title-opt" @click="addBank"><van-icon name="add-o" /> 添加银行卡</span>
                </div>
            </template>
            <van-cell v-for="item in bankList" :key="item.bankId" center :label="item.accountHolder" clickable @click="selectAccount(item)">
                <template>
                    <div @click.stop="editBank(item)">点击编辑<van-icon name="arrow" /></div>
                </template>
                <template #title>
                    <div class="bank-title">
                        <span style="font-weight: 600;">{{ item.bankName }}</span>
                        <div class="badge" v-show="item.bankIsDefault">默认</div>
                        <span class="withdraw-account">{{ item.bankAccount }}</span>
                        
                    </div>
                </template>
            </van-cell>
        </van-cell-group>
        <van-cell-group v-if="type == 'alipayWithdraw'">
            <template #title>
                <div class="account-group-title">
                    <span class="group-title">
                        <span style="color: black;">支付宝</span>
                        <span style="margin-left: 8px; font-size: 11px; color:red">即时到账</span>
                    </span>
                    <span class="group-title-opt" @click="addAlipay"><van-icon name="add-o" /> 添加支付宝</span>
                </div>
            </template>
            <van-cell v-for="item in alipayList" :key="item.bankId" center :label="item.accountHolder" clickable @click="selectAccount(item)">
                <template> 
                    <span @click.stop="editAlipay(item)">点击编辑<van-icon name="arrow" /></span>
                </template>
                <template #title>
                    <div class="bank-title">
                        <span class="withdraw-account">{{ item.bankAccount }}</span>
                        <div class="badge" v-show="item.bankIsDefault">默认</div>
                    </div>
                </template>
            </van-cell>
        </van-cell-group>
        <!-- <van-cell-group v-if="wechatPayList.length > 0">
            <template #title>
                <div class="account-group-title">
                    <span class="group-title">微信</span>
                </div>
            </template>
            <van-cell v-for="item in wechatPayList" :key="item.bankId" center :label="item.accountHolder" @click="selectAccount(item)">
                <template> 
                    <span @click.stop="editWxpay(item)">点击编辑<van-icon name="arrow" /></span>
                </template>
                <template #title>
                    <div class="bank-title">
                        <span class="withdraw-account">{{ item.bankAccount }}</span>
                        <div class="badge" v-show="item.bankIsDefault">默认</div>
                    </div>
                </template>
            </van-cell>
        </van-cell-group> -->
    </div>
</template>

<script>
import { getBankList } from "api/onLine"

export default {
    data() {
        return {
            bankList: [],
            alipayList: [],
            wechatPayList: [],
            coupon: this.$store.state.coupon,
            type: this.$route.query.type,
        }
    },
    mounted() {
        this.fetchBankList()
    },
    methods: {
        selectAccount(item) {
            console.log('select btn')
            if (!item.accountHolder) {
                this.$toast('请完善姓名信息')
                return
            }
            this.$push({ name: 'Withdraw', params: item, query: {type: this.type} })
        },
        addBank() {
            this.$push({ name: 'BankInfo' })
        },
        addAlipay() {
            this.$push({ path: 'alipay-info' })
        },
        editWxpay(wxpay) {
            this.$push({
                name: "WxpayInfo",
                query: {
                    bankId: wxpay.bankId,
                    bankName: wxpay.bankName,
                    accountHolder: wxpay.accountHolder,
                    isDefault: wxpay.bankIsDefault
                },
            })
        },
        fetchBankList() {
            getBankList(this.coupon.couponsNum).then((res) => {
                if (res.status == 200) {
                    if (res.data.length > 0) {
                        res.data.forEach((item) => {
                            if (item.bankType === 0) {
                                this.bankList.push(item)
                            } else if (item.bankType === 1) {
                                this.alipayList.push(item)
                            } else {
                                this.wechatPayList.push(item)
                            }
                        })
                    }
                } else {
                    this.$error(res.message)
                }
            })
        },
        editBank(bank, e) {      
            console.log('edit btn')      
            console.log(e)
            this.$push({
                name: "BankInfo",
                query: {
                    mode: 1,
                    bankId: bank.bankId,
                    bankName: bank.bankName,
                    bankAccount: bank.bankAccount,
                    accountHolder: bank.accountHolder,
                    isDefault: bank.bankIsDefault
                },
            })
        },
        editAlipay(alipay) {
            this.$push({
                name: "AlipayInfo",
                query: {
                    mode: 1,
                    bankId: alipay.bankId,
                    bankName: alipay.bankName,
                    bankAccount: alipay.bankAccount,
                    accountHolder: alipay.accountHolder,
                    isDefault: alipay.bankIsDefault
                },
            })
        }
    }
}
</script>

<style lang="css" scoped>
.account-list {
    padding: 10px;
}

.account-group-title {
    display: flex;
    justify-content: space-between;
}

.badge {
    position: fixed;
    margin-top: 3px;
    display: inline-block;
    padding: 0px 8px;
    color: #fb6a03;
    background-color: #e8e8e8;
    border-radius: 5px;
    font-size: 12px;
    line-height: 18px;
    height: 18px;
    margin: 2px 5px;
}
.withdraw-account {
    font-size: 18px;
    font-weight: 900;
    display: block;
}
</style>